import styled from 'styled-components';

export const Container = styled.table`
    width: 100%;
    font-size: 0.9rem;
    color: var(--colorFontsCardsDashboard);
    margin: 25px 0;

    thead{
        background: var(--colorBackgroundCardsDashboard);
        width: 100%;
        
        tr{
            position: relative;
            th{
                background: var(--colorBackgroundCardsDashboard);
                font-size: 17px;
                text-align: left;
                top: 0;
                position: sticky;

                @media(max-width: 800px){
                    font-size: 15px;
                }

                @media(max-width: 700px){
                    font-size: 13px;
                }
            }

            th:last-child{
                text-align: center;
            }

            th:nth-child(5){
                text-align: center;
            }
        }
    }

    tbody{
        tr{
            border-bottom: 1px solid #DDD;

            &:nth-child(even){
                background: #f2f2f2;
            }

            td{
                text-align: left;
            }

            td:last-child{
                text-align: center;
            }

            td:nth-child(5){
                text-align: center;
            }

            .T1{
                background-color: #2e9699;
                color: #Fff;
            }

            .T0{
                background-color: #F0E68C;
                color: #000;
            }

            .T-1{
                background-color: #e05f59;
                color: #fff;
            }

            .edit{
                display: flex;
                justify-content: space-around;
                align-items: center;

                svg{
                    cursor: pointer;
                }
            }
        }
    }

    th, td{
        padding: 0.15rem 0.35rem;
        font-size: 15px;
        height: 40px;

        @media(max-width: 800px){
            font-size: 13px;
        }

        @media(max-width: 700px){
            font-size: 12px;
        }
    }
`;
